import { REGISTERORG, RESETREGISTERORG, REGISTERORGUSER, REGISTERSUBSCRIBER, REGISTERFACULTY, REGISTERPARENT, REGISTERMINOR, REGISTERSTUDENT, REGISTERAVATAR } from "../actions/actionTypes";

// define initial state of auth reducer
const initialState = {
  organization: {
    name: "",
    LEA_ISD: "",
    facility: "",
    category: "",
    other: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "US",
    timezone: "",
    firstName: "",
    lastName: "",
    role: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    terms: true,
  },
  faculty: {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    facultyId: "",
    terms: true,
  },
  parent: {
    firstName: "",
    lastName: "",
    relationship: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    terms: true,
  },
  minorStudent: {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    phone: "",
    gradeLevel: "",
    schoolId: "",
    studentId: "",
    terms: true,
  },
  student: {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    phone: "",
    schoolId: "",
    studentId: "",
    gradeLevel: "",
    email: "",
    password: "",
    confirmPassword: "",
    terms: true,
  },
  orgUser: {
    organisationId: "",
    firstName: "",
    lastName: "",
    role: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    terms: true,
  },
  subscribers: {
    organisationId: "",
    firstName: "",
    lastName: "",
    role: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    terms: true,
  },
  file: {},
};

// update store based on type and payload and return the state
const register = (state = initialState, action) => {
  switch (action.type) {
    // Update register steps data
    case REGISTERORG: {
      const { data } = action.payload;
      return {
        ...state,
        organization: { ...state.organization, ...data }
      };
    }
    case REGISTERORGUSER: {
      const { data } = action.payload;
      return {
        ...state,
        orgUser: { ...state.orgUser, ...data }
      };
    }
    case REGISTERSUBSCRIBER: {
      const { data } = action.payload;
      return {
        ...state,
        subscribers: { ...state.subscribers, ...data }
      };
    }
    case REGISTERFACULTY: {
      const { data } = action.payload;
      return {
        ...state,
        faculty: { ...state.faculty, ...data }
      };
    }
    case REGISTERPARENT: {
      const { data } = action.payload;
      return {
        ...state,
        parent: { ...state.parent, ...data }
      };
    }
    case REGISTERMINOR: {
      const { data } = action.payload;
      return {
        ...state,
        minorStudent: { ...state.minorStudent, ...data }
      };
    }
    case REGISTERSTUDENT: {
      const { data } = action.payload;
      return {
        ...state,
        student: { ...state.student, ...data }
      };
    }
    case REGISTERAVATAR: {
      const { data } = action.payload;
      return {
        ...state,
        file: { ...data }
      };
    }
    case RESETREGISTERORG: {
      return {
        ...initialState
      };
    }
    default:
      return state;
  }
};

export default register;